/**
 * Formata um valor como moeda brasileira (ex.: "R$ 1.234,56", com o espaço
 * entre "R$" e o valor sendo U+00A0 — o que o próprio `Intl.NumberFormat`
 * produz, não um espaço comum). Fonte única de formatação monetária — não
 * reimplemente `Intl.NumberFormat('pt-BR', { style: 'currency', ... })` nem
 * `toLocaleString('pt-BR', { style: 'currency', ... })` em outro lugar (mesmo
 * padrão de dedupe de `core/utils/date.util.ts`).
 *
 * Recebe `number` (não nullable) de propósito: cada chamador decide como
 * tratar `null`/`undefined` (0, texto fixo, etc.) exatamente como fazia antes
 * — trocar a assinatura para aceitar nullable mudaria esse comportamento em
 * alguns pontos de chamada.
 */
export function formatarMoedaBRL(value: number): string {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

/**
 * Formata um número no padrão pt-BR (separador de milhar "." e decimal ",")
 * sem símbolo de moeda — para relatórios que exibem valores monetários ou
 * quantidades em coluna própria, com a unidade ("R$", "m²"...) no cabeçalho
 * da tabela em vez de embutida no valor.
 */
export function formatarNumeroPtBR(value: number, casas = 2): string {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  }).format(value);
}
